import Vue from "vue";
import GroupCommitmentRepository from "@/repositories/budget/GroupCommitmentRepository";

export interface GroupCommitment {
    uuid: string;
    label: string;
    type: string;
    amount: number;
    amountIncludingTax: number;
    parent: {
        uuid: string;
    };
    budget: {
        uuid: string;
    };
}

export default {
    state: {
        groupCommitment: [],
    },
    mutations: {
        setGroupCommitments: (state: any, groupCommitment: GroupCommitment[]) => {
          Vue.set(state, "groupCommitment", groupCommitment);
        },
    },
    getters: {
        getGroupCommitments: (state: any): GroupCommitment[] => {
            return state.groupCommitment;
        },
    },
    actions: {
        loadGroupCommitments: ({ commit }: any) => {
            GroupCommitmentRepository.get().then((data: any) => {
            commit("setGroupCommitments", data);
          });
        },
    },
};
